{
	"searchAssets": {
		"title": "Select ticker",
		"inputLabel": "Start typing ticker",
		"columnTicker": "Ticker",
		"columnExchange": "Exchange",
		"columnDescription": "Description",
		"tickersNotFound": "Tickers not found",
		"searching": "Searching...",
		"notHasWidgetUseLiveTicker": "No widgets using live ticker",
		"deleteSuccess": "{{symbol}} removed from watchlist",
		"deleteFail": "Failed to remove {{symbol}} from watchlist",
		"addSuccess": "{{symbol}} added to watchlist",
		"addFail": "Failed to add {{symbol}} to watchlist"
	}
}
